import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button, type SxProps, type Theme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { useDashboardTarget } from '@/hooks/useDashboardTarget';

export interface BackToDashboardLinkProps {
  sx?: SxProps<Theme>;
}

/**
 * A consistent "← Back to Dashboard" action for the account/identity pages, which otherwise strand
 * the user with no obvious return path. Resolves the destination + label from the current user's
 * role (`useDashboardTarget`), so it reads "Back to Candidate Dashboard" for a candidate and the
 * right thing for every other persona — without duplicating any persona's own navigation.
 */
export function BackToDashboardLink({ sx }: BackToDashboardLinkProps) {
  const dashboard = useDashboardTarget();

  return (
    <Button
      component={RouterLink}
      to={dashboard.path}
      startIcon={<ArrowBackIcon fontSize="small" />}
      size="small"
      color="inherit"
      sx={{ color: 'text.secondary', fontWeight: 500, ...sx }}
    >
      Back to {dashboard.label}
    </Button>
  );
}
